import React from 'react';
import CourseCollapsible from './CourseCollapsible';
import IDHelpers from '@/core/helpers/IDHelper';

interface IProps {
  data: any;
  selectPeriod: string;
}

const MyCoursesCollapsibles = (props: IProps) => {
  const { data, selectPeriod } = props;

  const selectRelatedCourse = (course: any) => {
    let relatedCourse = null;
    if (course?.relatedCourse?.code !== '') {
      relatedCourse = data.find(
        (c: any) =>
          c?.relatedCourse?.code === course?.relatedCourse?.code &&
          course?.title !== c?.title
      );
    }
    return relatedCourse;
  };

  return data?.map((course: any) => {
    const relatedCourse = selectRelatedCourse(course);
    return (
      <CourseCollapsible
        key={IDHelpers.generateID()}
        courseData={course}
        relatedCourse={relatedCourse}
        selectPeriod={selectPeriod}
      />
    );
  });
};

export default MyCoursesCollapsibles;
